/* eslint camelcase: 0 */

import { PublicationStorage as Data } from '@/typings/api/Publication'
import { Model, createMessages } from '@/helpers/Model'


export class PublicationStorageFileHistoryModel extends Model<Data> {
  public static readonly page_title = createMessages({
    ...Model.page_title,
    list: 'История файлов',
  });

  public static readonly modal_delete = createMessages({
    ...Model.modal_delete,
  });
}
